module.exports = "<article class=\"ui-card padding-lg margin-md\"\r\n    kd-promise=\"$ctrl.promise\"\r\n    style=\"margin:0 auto\"\r\n    max-width=\"lg\"\r\n    ng-bind-html=\"$ctrl.data\">\r\n</article>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/terminos/components/template.html
// module id = 160
// module chunks = 0